import { useEffect, useRef } from 'react';
import Icons from '../../../../components/Common/Icons/Icons';
import Dashboard from '../../../pages/dashboard';
import Sidebar from '../Sidebar';
import CheckingStatements from '../../../pages/statements/checking';
import MortgageStatements from '../../../pages/statements/mortgage';
import VisaClassicStatements from '../../../pages/statements/visa-classic';
import CheckImages from '../../../pages/checkImages';
import Notices from '../../../pages/notices';
import Taxes from '../../../pages/taxes';
import Profile from '../../../pages/profile';
import BatchDownload from '../../../pages/batch-download';
import UnreviewedDoc from '../../../pages/unreviewed-document';
import { useMenuContextProvider } from '../../../context/menu';
import { cn } from '../../../../utils/styles';
import { MenuRoute } from '../../../../components/Layout/Menu';
import AuthorizedViewers from '../../../pages/authorized-viewers';
import CreateAuthorizedViewers from '../../../pages/authorized-viewers/create';

export const guidanceRoutes: MenuRoute[] = [
  {
    name: 'Dashboard',
    icon: <Icons.Home />,
    route: {
      path: 'guidance',
      element: <Dashboard />,
    },
    children: [
      {
        name: 'Statements',
        icon: <Icons.Statement />,
        route: {
          path: 'statements',
        },
        childrenAsMenu: true,
        visibleOnlyWithAccount: true,
        children: [
          {
            name: 'Checking Statements',
            route: {
              path: 'checking-statements',
              element: <CheckingStatements />,
            },
          },
          {
            name: 'Mortgage Statements',
            route: {
              path: 'mortgage-statements',
              element: <MortgageStatements />,
            },
          },
          {
            name: 'VISA Classic',
            route: {
              path: 'visa-classic',
              element: <VisaClassicStatements />,
            },
          },
          {
            name: 'Unreviewed Documents',
            hidden: true,
            route: {
              path: 'unreviewed-document',
              element: <UnreviewedDoc />,
            },
          },
        ],
      },
      {
        name: 'Check Images',
        icon: <Icons.UserCheck />,
        route: {
          path: 'check-images',
          element: <CheckImages />,
        },
        visibleOnlyWithAccount: true,
      },
      {
        name: 'eTax',
        icon: <Icons.Tax />,
        route: {
          path: 'taxes',
          element: <Taxes />,
        },
      },
      {
        name: 'eNotices',
        icon: <Icons.Check />,
        route: {
          path: 'notices',
          element: <Notices />,
        },
      },
      {
        name: 'Profile',
        hidden: true,
        route: {
          path: 'profile',
          element: <Profile />,
        },
      },
      {
        name: 'Manage Authorized Viewers',
        hidden: true,
        route: {
          path: 'authorized-viewers',
          element: <AuthorizedViewers />,
        },
      },
      {
        name: 'Create Authorized Viewers',
        hidden: true,
        route: {
          path: 'create-authorized-viewers',
          element: <CreateAuthorizedViewers />,
        },
      },
      {
        name: 'BatchDownload',
        hidden: true,
        route: {
          path: 'batch-download',
          element: <BatchDownload />,
        },
      },
    ],
  },
];

export default function GuidanceMenu() {
  const menuRef = useRef<HTMLDivElement>(null);
  const { isMenuOpen, toggleMenu } = useMenuContextProvider();

  // @ts-ignore ignore any type below
  const handleClickOutside = (e: any) => {
    if (isMenuOpen && menuRef.current && !menuRef.current.contains(e.target)) {
      toggleMenu();
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);

    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [isMenuOpen]);

  return (
    <div
      className={cn(
        'lg:relative fixed min-h-[100vh] transition-transform' +
          ' translate-x-[-240px] lg:transition-none lg:translate-x-[0] z-[10] top-0 left-0',
        {
          'translate-x-[0]': isMenuOpen,
        },
      )}
      ref={menuRef}
    >
      <Sidebar />
    </div>
  );
}
